import { HttpErrorResponse } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot
} from "@angular/router";
import { UserBackend } from "src/app/backend/api/user.backend";
import { sntLog } from "src/app/common/logger";
import { sntNavigate } from "src/app/support/router";
import { lastValueFrom } from "rxjs";

const logger = sntLog("ProcessInviteGuard");

@Injectable()
export class ProcessInviteGuard {
  private readonly router = inject(Router);
  private readonly userBackend = inject(UserBackend);

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    logger.info("canActivate");
    logger.info(state.url);

    const inviteId = route.queryParamMap.get("invite");

    if (!inviteId) {
      return true;
    }

    const url = new URL(`${location.origin}${state.url}`);
    url.searchParams.delete("invite");
    url.searchParams.delete("email");

    try {
      await lastValueFrom(this.userBackend.acceptInvite(inviteId));

      sntNavigate(this.router, [`invite`, inviteId, "accepted"], {
        queryParams: {
          returnUrl: `${url.pathname}${url.search}`
        }
      });
    } catch (ex) {
      const httpErrorResponse = ex as HttpErrorResponse;

      sntNavigate(this.router, [`invite`, inviteId, "failed"], {
        queryParams: {
          returnUrl: `${url.pathname}${url.search}`,
          httpStatus: httpErrorResponse.status
        }
      });
    }

    return false;
  }
}
